import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import Header from "components/Header";
import { routes } from "constants/routes";
import useDeviceType from "hooks/useDeviceType";
import MainLayout from "layouts/Main";
import { ISummaryData } from "models/HaulPay";
import SearchInput from "../../modules/FRListByStatusDesktop/components/SearchInput";
import StatusSummary from "../../Shared/StatusSummary";
import AssignedLoadsListByStatusDesktop from "./ListByStatusDesktop";
import { QUERY_ASSIGNED_LOADS_SUMMARY } from "./query";
import { BrokerProvider } from "context/BrokerContext";
import { usePullToRefresh } from "context/PullToRefreshContext";

function AssignedLoadsContent() {
  const navigate = useNavigate();
  const { isDesktop } = useDeviceType();

  const { data: FRSummaryData, refetch } = useQuery(QUERY_ASSIGNED_LOADS_SUMMARY, {
    variables: {
      assignedLoads: true
    },
    fetchPolicy: "cache-and-network"
  });
  usePullToRefresh(refetch);

  const handleSearch = (value: string) => {
    navigate(`${location.pathname}/all`, { state: { searchValue: value } });
  };

  const render = (summaryData: ISummaryData) => {
    return !isDesktop ? (
      <>
        <SearchInput
          initialValue=""
          onSearch={handleSearch}
          isMobile={true}
          iconClassName="absolute inset-y-0 my-auto text-placeholder left-4"
        />
        <StatusSummary summaryData={summaryData} />
      </>
    ) : (
      <AssignedLoadsListByStatusDesktop refetchSummaryData={refetch} summaryData={summaryData} />
    );
  };

  return (
    <MainLayout
      desktopTitle="Assigned"
      customHeader={<Header label="Assigned" goBackPath={routes.HAULPAY} isHideDesktop />}
      className="px-5 pb-24">
      {FRSummaryData ? render(FRSummaryData.fundingRequestsSummary.data) : null}
    </MainLayout>
  );
}

export default function AssignedLoads() {
  return (
    <BrokerProvider>
      <AssignedLoadsContent />
    </BrokerProvider>
  );
}
